import axios from '@/utils/request'

const state = {
  permList: {} // 权限列表
}

const mutations = {

  /**
   * 保存用户权限
   * @param {any} state 状态数据
   * @param {any} view 数据
   */
  SET_PERM_LIST(state, data) {
    state.permList = JSON.parse(JSON.stringify(data))
  }
}

const actions = {

  /**
   * 获取用户权限
   * @param {any} param0 与 store 实例具有相同方法和属性的 context 对象
   */
  async getPermission({ commit }) {
    try {
      const { data: result } = await axios.get('/sys/user/hasPermission')
      if (result.status === '000000') {
        commit('SET_PERM_LIST', result.result)
      }
    } catch (error) {
      console.log('获取用户权限-请求失败', error)
    }
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
